/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../channels/channels';
import './onlinestore';
import '../api/sync/sync';
import '../connect/v2/catalog/resources/datatypes';
import '../connect/v2/catalog/resources/enums';
import '../common/dinero';
import './rule_types';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "api": {
        "nested": {
          "items": {
            "nested": {
              "CalculationPhase": {
                "values": {
                  "DISCOUNT_PERCENTAGE_PHASE": 0,
                  "DISCOUNT_AMOUNT_PHASE": 1,
                  "FEE_SUBTOTAL_PHASE": 2,
                  "FEE_TOTAL_PHASE": 3,
                  "TIP_PHASE": 4,
                  "SWEDISH_ROUNDING_PHASE": 5,
                  "SURCHARGE_PHASE": 6,
                  "SURCHARGE_TOTAL_PHASE": 7,
                  "APPORTIONED_SURCHARGE_PERCENTAGE_PHASE": 8,
                  "APPORTIONED_SURCHARGE_AMOUNT_PHASE": 9,
                  "CARD_SURCHARGE_PHASE": 10
                }
              },
              "OBSOLETE_CurrencyCode": {
                "values": {
                  "USD": 0
                }
              },
              "Visibility": {
                "values": {
                  "PUBLIC": 0,
                  "PUBLIC_ONLY": 2,
                  "PRIVATE": 1
                }
              },
              "PricingType": {
                "values": {
                  "FIXED_PRICING": 0,
                  "VARIABLE_PRICING": 1
                }
              },
              "StraightFireType": {
                "values": {
                  "UNKNOWN_STRAIGHT_FIRE": 0,
                  "NEVER": 1,
                  "ALWAYS": 2
                }
              },
              "ProductName": {
                "values": {
                  "DO_NOT_USE_MENU_PRODUCT_NAME": 0,
                  "RESTAURANTS": 1,
                  "RETAIL": 2,
                  "STANDARD": 3
                }
              },
              "MerchantCatalogObjectReference": {
                "fields": {
                  "catalogObjectToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ItemOptionForItem": {
                "fields": {
                  "itemOptionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ChannelIntegration": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "channelType": {
                    "type": ".squareup.channels.Reference.Type",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CatalogProgramType": {
                "values": {
                  "PROGRAM_DO_NOT_USE": 0,
                  "SNAP": 1,
                  "EBT_CASH": 2
                }
              },
              "CatalogProgramEligibilityStatus": {
                "values": {
                  "ELIGIBILITY_DO_NOT_USE": 0,
                  "INELIGIBLE": 1,
                  "ELIGIBLE": 2
                }
              },
              "ProgramEligibility": {
                "fields": {
                  "program": {
                    "type": ".squareup.api.items.CatalogProgramType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibility": {
                    "type": ".squareup.api.items.CatalogProgramEligibilityStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Item": {
                "fields": {
                  "visibility": {
                    "type": ".squareup.api.items.Visibility",
                    "id": 9,
                    "rule": "optional"
                  },
                  "buyerFacingName": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "availableOnline": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "availableForPickup": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "availableElectronically": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "onlineStoreItemData": {
                    "type": ".squareup.api.items.OnlineStoreItemData",
                    "id": 19,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "color": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "taxable": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "abbreviation": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "menuCategory": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 7,
                    "rule": "optional"
                  },
                  "image": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 8,
                    "rule": "optional"
                  },
                  "pricingType": {
                    "type": ".squareup.api.items.PricingType",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": "FIXED_PRICING"
                    }
                  },
                  "archetype": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 11,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.api.items.Item.Type",
                    "id": 16,
                    "rule": "optional",
                    "options": {
                      "default": "REGULAR"
                    }
                  },
                  "skipsModifierScreen": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 21,
                    "rule": "optional"
                  },
                  "tagMembership": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "straightFireOverride": {
                    "type": ".squareup.api.items.StraightFireType",
                    "id": 23,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "ecomUri": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "ecomImageUris": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "ecomAvailable": {
                    "type": "bool",
                    "id": 27,
                    "rule": "optional"
                  },
                  "itemOptions": {
                    "type": ".squareup.api.items.ItemOptionForItem",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "customAttributeValues": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "ecomBuyButtonText": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "ecomVisibility": {
                    "type": ".squareup.api.items.Item.EcomVisibility",
                    "id": 32,
                    "rule": "optional",
                    "options": {
                      "default": "UNINDEXED"
                    }
                  },
                  "sortName": {
                    "type": "string",
                    "id": 33,
                    "rule": "optional"
                  },
                  "sortNameOrName": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.api.items.ImageReference",
                    "id": 35,
                    "rule": "repeated"
                  },
                  "kitchenName": {
                    "type": "string",
                    "id": 36,
                    "rule": "optional"
                  },
                  "additionalCategories": {
                    "type": ".squareup.api.items.CategoryId",
                    "id": 37,
                    "rule": "repeated"
                  },
                  "pickupFulfillmentPreferencesId": {
                    "type": "string",
                    "id": 38,
                    "rule": "optional"
                  },
                  "deliveryFulfillmentPreferencesId": {
                    "type": "string",
                    "id": 39,
                    "rule": "optional"
                  },
                  "htmlDescription": {
                    "type": "string",
                    "id": 40,
                    "rule": "optional"
                  },
                  "ecomAllowOrderItemQuantities": {
                    "type": "bool",
                    "id": 41,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "ecomOrderItemMaxQuantity": {
                    "type": "int32",
                    "id": 42,
                    "rule": "optional"
                  },
                  "channels": {
                    "type": "string",
                    "id": 43,
                    "rule": "repeated"
                  },
                  "shippingFulfillmentPreferencesId": {
                    "type": "string",
                    "id": 44,
                    "rule": "optional"
                  },
                  "dineInFulfillmentPreferencesId": {
                    "type": "string",
                    "id": 45,
                    "rule": "optional"
                  },
                  "isArchived": {
                    "type": "bool",
                    "id": 46,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "requiresSubscriptionToSell": {
                    "type": "bool",
                    "id": 47,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "ageRestrictionId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 48,
                    "rule": "optional"
                  },
                  "ecomSeoPageTitle": {
                    "type": "string",
                    "id": 49,
                    "rule": "optional"
                  },
                  "ecomSeoPageDescription": {
                    "type": "string",
                    "id": 50,
                    "rule": "optional"
                  },
                  "ecomSeoPermalink": {
                    "type": "string",
                    "id": 51,
                    "rule": "optional"
                  },
                  "posDisplayName": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "combo": {
                    "type": ".squareup.api.items.Item.Combo",
                    "id": 53,
                    "rule": "optional"
                  },
                  "foodAndBeverageDetails": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails",
                    "id": 54,
                    "rule": "optional"
                  },
                  "openGraphLinkTitle": {
                    "type": "string",
                    "id": 55,
                    "rule": "optional"
                  },
                  "openGraphLinkDescription": {
                    "type": "string",
                    "id": 56,
                    "rule": "optional"
                  },
                  "isAlcoholic": {
                    "type": "bool",
                    "id": 57,
                    "rule": "optional"
                  },
                  "channelIntegrations": {
                    "type": ".squareup.api.items.ChannelIntegration",
                    "id": 58,
                    "rule": "repeated"
                  },
                  "programEligibilities": {
                    "type": ".squareup.api.items.ProgramEligibility",
                    "id": 59,
                    "rule": "repeated"
                  },
                  "event": {
                    "type": ".squareup.api.items.Item.Event",
                    "id": 60,
                    "rule": "optional"
                  },
                  "preselectFirstVariation": {
                    "type": "bool",
                    "id": 61,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "REGULAR": 0,
                      "GIFT_CARD": 1,
                      "APPOINTMENTS_SERVICE": 2,
                      "CLASS_TICKET": 5,
                      "FOOD_AND_BEV": 6,
                      "EVENT": 7,
                      "DIGITAL": 8,
                      "DONATION": 9,
                      "MEMBERSHIP": 10,
                      "CREDIT_PACKAGE": 11,
                      "OTHER": 12,
                      "COMBO": 13,
                      "LEGACY_SQUARE_ONLINE_SERVICE": 14,
                      "LEGACY_SQUARE_ONLINE_MEMBERSHIP": 15,
                      "APPOINTMENTS_MEMBERSHIP": 16
                    }
                  },
                  "EcomVisibility": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "UNINDEXED": 1,
                      "UNAVAILABLE": 2,
                      "HIDDEN": 3,
                      "VISIBLE": 4
                    }
                  },
                  "Combo": {
                    "fields": {
                      "slots": {
                        "type": ".squareup.api.items.Item.Combo.Slot",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Slot": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "numSelections": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "defaultItemVariationId": {
                            "type": ".squareup.api.sync.ObjectId",
                            "id": 4,
                            "rule": "optional"
                          },
                          "itemId": {
                            "type": ".squareup.api.sync.ObjectId",
                            "id": 5,
                            "rule": "optional"
                          },
                          "categoryId": {
                            "type": ".squareup.api.sync.ObjectId",
                            "id": 6,
                            "rule": "optional"
                          },
                          "itemIds": {
                            "type": ".squareup.api.sync.ObjectId",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "itemVariationIds": {
                            "type": ".squareup.api.sync.ObjectId",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "priceAdjustments": {
                            "type": ".squareup.api.items.Item.Combo.Slot.PriceAdjustment",
                            "id": 9,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "PriceAdjustment": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "itemVariationId": {
                                "type": ".squareup.api.sync.ObjectId",
                                "id": 2,
                                "rule": "required"
                              },
                              "amount": {
                                "type": "int32",
                                "id": 3,
                                "rule": "required"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "Event": {
                    "fields": {
                      "startAt": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "endAt": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "eventLocationTimeZone": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "eventLocationName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "eventLocationTypes": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.EventLocationType",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "onlineUrl": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "addressId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "allDayEvent": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CategoryId": {
                "fields": {
                  "categoryId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinalWithinCategory": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ImageReference": {
                "fields": {
                  "imageId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ItemModifierList": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "selectionType": {
                    "type": ".squareup.api.items.ItemModifierList.SelectionType",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "SINGLE"
                    }
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isConversational": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.api.items.ImageReference",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "allowQuantities": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "maxQuantity": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": 10
                    }
                  },
                  "modifierType": {
                    "type": ".squareup.api.items.ItemModifierList.ModifierType",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "LIST"
                    }
                  },
                  "maxLength": {
                    "type": "int32",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": 150
                    }
                  },
                  "textRequired": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "internalName": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "hiddenFromCustomer": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "minSelectedModifiers": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional",
                    "options": {
                      "default": -1
                    }
                  },
                  "maxSelectedModifiers": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional",
                    "options": {
                      "default": -1
                    }
                  },
                  "channelIntegrations": {
                    "type": ".squareup.api.items.ChannelIntegration",
                    "id": 18,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "SelectionType": {
                    "values": {
                      "SINGLE": 0,
                      "MULTIPLE": 1
                    }
                  },
                  "ModifierType": {
                    "values": {
                      "LIST": 0,
                      "TEXT": 1
                    }
                  }
                }
              },
              "ItemModifierOption": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "price": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "onByDefault": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "modifierList": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 5,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 7,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "kitchenName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "soldOut": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "soldOutValidUntil": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "imageId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 12,
                    "rule": "optional"
                  },
                  "hiddenOnline": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "childModifierListIds": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "kitchenColor": {
                    "type": "int32",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "ItemOptionValueForItemVariation": {
                "fields": {
                  "itemOptionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemOptionValueId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Intermission": {
                "fields": {
                  "startOffset": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endOffset": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ItemVariation": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "buyerFacingName": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "sku": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gtin": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "price": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pricingType": {
                    "type": ".squareup.api.items.PricingType",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": "FIXED_PRICING"
                    }
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "item": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 6,
                    "rule": "optional"
                  },
                  "inventoryAlertType": {
                    "type": ".squareup.api.items.ItemVariation.InventoryAlertType",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": "NONE"
                    }
                  },
                  "inventoryAlertThreshold": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "trackInventory": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "userData": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "serviceDuration": {
                    "type": "int64",
                    "id": 18,
                    "rule": "optional"
                  },
                  "priceDescription": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "transitionTime": {
                    "type": "int64",
                    "id": 21,
                    "rule": "optional"
                  },
                  "noShowFeeMoney": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 22,
                    "rule": "optional"
                  },
                  "availableOnOnlineBookingSite": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "employeeTokens": {
                    "type": "string",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 19,
                    "rule": "optional"
                  },
                  "measurementUnitToken": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "itemOptionValues": {
                    "type": ".squareup.api.items.ItemOptionValueForItemVariation",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "intermissions": {
                    "type": ".squareup.api.items.Intermission",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "customAttributeValues": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "resourceTokens": {
                    "type": "string",
                    "id": 31,
                    "rule": "repeated"
                  },
                  "stockable": {
                    "type": "bool",
                    "id": 32,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "sellable": {
                    "type": "bool",
                    "id": 33,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "compositionToken": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "soldOut": {
                    "type": "bool",
                    "id": 35,
                    "rule": "optional"
                  },
                  "stockableItemVariation": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 36,
                    "rule": "optional"
                  },
                  "stockableQuantity": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  },
                  "nonstockableQuantity": {
                    "type": "string",
                    "id": 38,
                    "rule": "optional"
                  },
                  "soldOutValidUntil": {
                    "type": "string",
                    "id": 39,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.api.items.ImageReference",
                    "id": 40,
                    "rule": "repeated"
                  },
                  "kitchenName": {
                    "type": "string",
                    "id": 41,
                    "rule": "optional"
                  },
                  "contractTemplateTokens": {
                    "type": "string",
                    "id": 42,
                    "rule": "repeated"
                  },
                  "channels": {
                    "type": "string",
                    "id": 43,
                    "rule": "repeated"
                  },
                  "bundle": {
                    "type": ".squareup.api.items.ItemVariation.Bundle",
                    "id": 45,
                    "rule": "optional"
                  },
                  "weight": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.ItemVariationWeight",
                    "id": 46,
                    "rule": "optional"
                  },
                  "creditsValidityDuration": {
                    "type": "string",
                    "id": 47,
                    "rule": "optional"
                  },
                  "recipeToken": {
                    "type": "string",
                    "id": 48,
                    "rule": "optional"
                  },
                  "serviceCost": {
                    "type": ".squareup.api.items.ItemVariation.ServiceCost",
                    "id": 49,
                    "rule": "optional"
                  },
                  "vendorInformation": {
                    "type": ".squareup.api.items.ItemVariation.VendorInformation",
                    "id": 50,
                    "rule": "repeated"
                  },
                  "noShowFeePercentage": {
                    "type": "int32",
                    "id": 51,
                    "rule": "optional"
                  },
                  "depositAmount": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 52,
                    "rule": "optional"
                  },
                  "depositPercentage": {
                    "type": "string",
                    "id": 53,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "InventoryAlertType": {
                    "values": {
                      "INVENTORY_ALERT_TYPE_DO_NOT_USE": 0,
                      "NONE": 1,
                      "LOW_QUANTITY": 2
                    }
                  },
                  "Bundle": {
                    "fields": {
                      "quantityRatio": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                        "id": 1,
                        "rule": "optional"
                      },
                      "components": {
                        "type": ".squareup.api.items.ItemVariation.Bundle.Component",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Component": {
                        "fields": {
                          "quantityRatio": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 1,
                            "rule": "optional"
                          },
                          "variationMerchantCatalogToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "variationCogsId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "ServiceCost": {
                    "fields": {
                      "pricingType": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.ServiceCostType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "amountFlat": {
                        "type": ".squareup.common.dinero.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "amountPercent": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "VendorInformation": {
                    "fields": {
                      "vendorId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitCostMoney": {
                        "type": ".squareup.common.dinero.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "vendorCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ItemImage": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sha1": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "MenuCategory": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 4,
                    "rule": "optional"
                  },
                  "straightFire": {
                    "type": ".squareup.api.items.StraightFireType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "color": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "abbreviation": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.api.items.ImageReference",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "channelId": {
                    "type": "string",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "categoryId": {
                    "type": ".squareup.api.items.CategoryId",
                    "id": 11,
                    "rule": "optional"
                  },
                  "categoryType": {
                    "type": ".squareup.api.items.MenuCategory.CatalogCategoryType",
                    "id": 12,
                    "rule": "optional"
                  },
                  "timePeriodTokens": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "isTopLevel": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "rootCategory": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 15,
                    "rule": "optional"
                  },
                  "ecomSeoPageTitle": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "ecomSeoPageDescription": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "ecomSeoPermalink": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "openGraphLinkTitle": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "openGraphLinkDescription": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "migratedFromSquareOnline": {
                    "type": "bool",
                    "id": 21,
                    "rule": "optional"
                  },
                  "availabilityPeriodTokens": {
                    "type": "string",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "onlineVisibility": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "channelIntegrations": {
                    "type": ".squareup.api.items.ChannelIntegration",
                    "id": 24,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CatalogCategoryType": {
                    "values": {
                      "CATALOG_CATEGORY_TYPE_DO_NOT_USE": 0,
                      "REGULAR_CATEGORY": 1,
                      "MENU_CATEGORY": 2,
                      "KITCHEN_CATEGORY": 3
                    }
                  }
                }
              },
              "Fee": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "calculationPhase": {
                    "type": ".squareup.api.items.CalculationPhase",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "FEE_SUBTOTAL_PHASE"
                    }
                  },
                  "feeTypeId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "feeTypeName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "adjustmentType": {
                    "type": ".squareup.api.items.Fee.AdjustmentType",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "TAX"
                    }
                  },
                  "appliesToCustomAmounts": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "enabled": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "inclusionType": {
                    "type": ".squareup.api.items.Fee.InclusionType",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": "ADDITIVE"
                    }
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 16,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "appliesToProductSet": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 18,
                    "rule": "optional"
                  },
                  "isSecondaryTax": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AdjustmentType": {
                    "values": {
                      "TAX": 0,
                      "OBSOLETE_SURCHARGE": 1
                    }
                  },
                  "InclusionType": {
                    "values": {
                      "ADDITIVE": 0,
                      "INCLUSIVE": 1
                    }
                  }
                }
              },
              "Discount": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "color": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "pinRequired": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "discountType": {
                    "type": ".squareup.api.items.Discount.DiscountType",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": "FIXED"
                    }
                  },
                  "applicationMethod": {
                    "type": ".squareup.api.items.Discount.ApplicationMethod",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": "MANUALLY_APPLIED"
                    }
                  },
                  "compOrdinal": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 11,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "modifyTaxBasis": {
                    "type": ".squareup.api.items.Discount.ModifyTaxBasis",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": "MODIFY_TAX_BASIS"
                    }
                  },
                  "maximumAmount": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DiscountType": {
                    "values": {
                      "FIXED": 0,
                      "VARIABLE_PERCENTAGE": 1,
                      "VARIABLE_AMOUNT": 2
                    }
                  },
                  "ApplicationMethod": {
                    "values": {
                      "MANUALLY_APPLIED": 0,
                      "COMP": 1
                    }
                  },
                  "ModifyTaxBasis": {
                    "values": {
                      "MODIFY_TAX_BASIS": 0,
                      "DO_NOT_MODIFY_TAX_BASIS": 1
                    }
                  }
                }
              },
              "DiningOption": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 4,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "TaxRule": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "condition": {
                    "type": ".squareup.api.items.TaxRule.Condition",
                    "id": 3,
                    "rule": "optional"
                  },
                  "taxConfig": {
                    "type": ".squareup.api.items.TaxSetConfiguration",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actionType": {
                    "type": ".squareup.api.items.EnablingActionType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "itemConfig": {
                    "type": ".squareup.api.items.ItemSetConfiguration",
                    "id": 6,
                    "rule": "optional"
                  },
                  "exemptProductSet": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 7,
                    "rule": "optional"
                  },
                  "appliesToCustomAmounts": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "adjustmentTax": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 9,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Condition": {
                    "fields": {
                      "diningOptionPredicate": {
                        "type": ".squareup.api.items.ObjectPredicate",
                        "id": 1,
                        "rule": "optional"
                      },
                      "maxTotalAmount": {
                        "type": ".squareup.common.dinero.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "minItemPrice": {
                        "type": ".squareup.common.dinero.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxItemPrice": {
                        "type": ".squareup.common.dinero.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "quantityGreaterThan": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "quantityLessThan": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "quantityEqualsTo": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PageLayout": {
                "values": {
                  "UNKNOWN_PAGE_LAYOUT": 0,
                  "FLEXIBLE": 1,
                  "IMAGE_TILES_5X5": 2,
                  "TEXT_TILES_3X9": 3,
                  "IMAGE_TEXT_TILES_8X8": 4,
                  "IMAGE_TEXT_TILES_12X11": 5,
                  "IMAGE_TEXT_TILES_12X8": 6,
                  "IMAGE_TEXT_TILES_16X11": 7,
                  "IMAGE_TILES_2X10": 8,
                  "IMAGE_TEXT_TILES_10X10": 9,
                  "IMAGE_TEXT_TILES_2XINFINITE": 10
                }
              },
              "DeviceFormFactor": {
                "values": {
                  "DO_NOT_USE_DEVICE_FORM_FACTOR": 0,
                  "TABLET": 1,
                  "MOBILE": 2,
                  "UNIVERSAL": 3
                }
              },
              "TicketTemplate": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ticketGroup": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 4,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "TicketGroup": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "namingMethod": {
                    "type": ".squareup.api.items.TicketGroup.NamingMethod",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "AUTOMATIC_NUMBERING"
                    }
                  },
                  "label": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "numberingStartsAt": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "prefixTableNames": {
                    "type": ".squareup.api.items.TicketGroup.PrefixTableNames",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": "NONE"
                    }
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "NamingMethod": {
                    "values": {
                      "AUTOMATIC_NUMBERING": 0,
                      "MANUAL": 1
                    }
                  },
                  "PrefixTableNames": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NONE": 1,
                      "SECTION": 2
                    }
                  }
                }
              },
              "Menu": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rootTag": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 3,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 4,
                    "rule": "optional"
                  },
                  "productName": {
                    "type": ".squareup.api.items.ProductName",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "multiUnitMode": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "layout": {
                    "type": ".squareup.api.items.PageLayout",
                    "id": 8,
                    "rule": "optional"
                  },
                  "tags": {
                    "type": ".squareup.api.items.TagReference",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "deviceFormFactor": {
                    "type": ".squareup.api.items.DeviceFormFactor",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "TagReference": {
                "fields": {
                  "tagId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Surcharge": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.api.items.Surcharge.Type",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxable": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "calculationPhase": {
                    "type": ".squareup.api.items.CalculationPhase",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "SURCHARGE_PHASE"
                    }
                  },
                  "autoGratuity": {
                    "type": ".squareup.api.items.Surcharge.AutoGratuitySettings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "catalogObjectReference": {
                    "type": ".squareup.api.items.MerchantCatalogObjectReference",
                    "id": 9,
                    "rule": "optional"
                  },
                  "color": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "calculationType": {
                    "type": ".squareup.api.items.Surcharge.CalculationType",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "FIXED"
                    }
                  },
                  "ecomApplyToFulfillmentTypes": {
                    "type": ".squareup.api.items.Surcharge.EcomFulfillmentType",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "treatmentType": {
                    "type": ".squareup.api.items.Surcharge.TreatmentType",
                    "id": 13,
                    "rule": "optional"
                  },
                  "programEligibilities": {
                    "type": ".squareup.api.items.ProgramEligibility",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "surchargeBasis": {
                    "type": ".squareup.common.dinero.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "paymentClientToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "AUTO_GRATUITY": 1,
                      "CUSTOM": 2,
                      "CARD_SURCHARGE": 3
                    }
                  },
                  "AutoGratuitySettings": {
                    "fields": {
                      "minimumSeatCount": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "autoEnableType": {
                        "type": ".squareup.api.items.Surcharge.AutoGratuitySettings.AutoEnableType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hasBeenManuallyToggled": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    },
                    "nested": {
                      "AutoEnableType": {
                        "values": {
                          "UNKNOWN": 0,
                          "MINIMUM_SEAT_COUNT": 1,
                          "ALWAYS": 2
                        }
                      }
                    }
                  },
                  "CalculationType": {
                    "values": {
                      "FIXED": 0,
                      "VARIABLE_PERCENTAGE": 1,
                      "VARIABLE_AMOUNT": 2
                    }
                  },
                  "EcomFulfillmentType": {
                    "values": {
                      "PICKUP": 1,
                      "DELIVERY": 2,
                      "DINE_IN": 3,
                      "SHIPPING": 4
                    }
                  },
                  "TreatmentType": {
                    "values": {
                      "LINE_ITEM": 1,
                      "APPORTIONED": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.CalculationPhase && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.OBSOLETE_CurrencyCode && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Visibility && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.PricingType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.StraightFireType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ProductName && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.MerchantCatalogObjectReference && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemOptionForItem && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ChannelIntegration && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.CatalogProgramType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.CatalogProgramEligibilityStatus && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ProgramEligibility && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.Type && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.EcomVisibility && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.Combo && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.Combo?.nested?.Slot && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.Combo?.nested?.Slot?.nested?.PriceAdjustment && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Item?.nested?.Event && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.CategoryId && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ImageReference && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemModifierList && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemModifierList?.nested?.SelectionType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemModifierList?.nested?.ModifierType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemModifierOption && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemOptionValueForItemVariation && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Intermission && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation?.nested?.InventoryAlertType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation?.nested?.Bundle && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation?.nested?.Bundle?.nested?.Component && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation?.nested?.ServiceCost && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemVariation?.nested?.VendorInformation && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemImage && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.MenuCategory && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.MenuCategory?.nested?.CatalogCategoryType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Fee && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Fee?.nested?.AdjustmentType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Fee?.nested?.InclusionType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Discount && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Discount?.nested?.DiscountType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Discount?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Discount?.nested?.ModifyTaxBasis && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.DiningOption && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TaxRule && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TaxRule?.nested?.Condition && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.PageLayout && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.DeviceFormFactor && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TicketTemplate && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TicketGroup && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TicketGroup?.nested?.NamingMethod && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TicketGroup?.nested?.PrefixTableNames && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Menu && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TagReference && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.Type && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.AutoGratuitySettings && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.AutoGratuitySettings?.nested?.AutoEnableType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.CalculationType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.EcomFulfillmentType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.Surcharge?.nested?.TreatmentType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CalculationPhase @ squareup/items/items.proto at 82:1
 */
export const CalculationPhase = $root.lookupEnum('squareup.api.items.CalculationPhase').values;
/**
 * SOURCE OBSOLETE_CurrencyCode @ squareup/items/items.proto at 172:1
 */
export const OBSOLETE_CurrencyCode = $root.lookupEnum('squareup.api.items.OBSOLETE_CurrencyCode').values;
/**
 * SOURCE Visibility @ squareup/items/items.proto at 181:1
 */
export const Visibility = $root.lookupEnum('squareup.api.items.Visibility').values;
/**
 * SOURCE PricingType @ squareup/items/items.proto at 196:1
 */
export const PricingType = $root.lookupEnum('squareup.api.items.PricingType').values;
/**
 * Describes whether the object should always straight fire by default
 * or never straight fire by default.
 *
 * SOURCE StraightFireType @ squareup/items/items.proto at 205:1
 */
export const StraightFireType = $root.lookupEnum('squareup.api.items.StraightFireType').values;
/**
 * Describes which Square Product the object is associated with.
 *
 * SOURCE ProductName @ squareup/items/items.proto at 217:1
 */
export const ProductName = $root.lookupEnum('squareup.api.items.ProductName').values;
/**
 * A reference to a Merchant Catalog (Items V3) object. See the CatalogObject
 * message defined in
 * https://github.com/squareup/go-square/blob/master/items/protos/squareup/merchant/api.proto
 *
 * SOURCE MerchantCatalogObjectReference @ squareup/items/items.proto at 245:1
 */
export const MerchantCatalogObjectReference = $root.lookupType('squareup.api.items.MerchantCatalogObjectReference');
fixType(MerchantCatalogObjectReference);
Builder.createAndAttachToType(MerchantCatalogObjectReference);
/**
 * SOURCE ItemOptionForItem @ squareup/items/items.proto at 250:1
 */
export const ItemOptionForItem = $root.lookupType('squareup.api.items.ItemOptionForItem');
fixType(ItemOptionForItem);
Builder.createAndAttachToType(ItemOptionForItem);
/**
 * SOURCE ChannelIntegration @ squareup/items/items.proto at 254:1
 */
export const ChannelIntegration = $root.lookupType('squareup.api.items.ChannelIntegration');
fixType(ChannelIntegration);
Builder.createAndAttachToType(ChannelIntegration);
/**
 * --
 * @desc The program types that a catalog object can be eligible for
 * --
 *
 * SOURCE CatalogProgramType @ squareup/items/items.proto at 263:1
 */
export const CatalogProgramType = $root.lookupEnum('squareup.api.items.CatalogProgramType').values;
/**
 * --
 * @desc Eligibility status for a program
 * --
 *
 * SOURCE CatalogProgramEligibilityStatus @ squareup/items/items.proto at 276:1
 */
export const CatalogProgramEligibilityStatus = $root.lookupEnum('squareup.api.items.CatalogProgramEligibilityStatus').values;
/**
 * SOURCE ProgramEligibility @ squareup/items/items.proto at 286:1
 */
export const ProgramEligibility = $root.lookupType('squareup.api.items.ProgramEligibility');
fixType(ProgramEligibility);
Builder.createAndAttachToType(ProgramEligibility);
/**
 * SOURCE Item @ squareup/items/items.proto at 294:1
 */
export const Item = $root.lookupType('squareup.api.items.Item');
fixType(Item);
Builder.createAndAttachToType(Item);
/**
 * NOTE: Android register clients are not forward compatible with new item
 * types, i.e. handling unknown types gracefully with a degraded experience.
 * New types must be filtered out for old devices with a new catalog feature
 * to avoid crashes or other unexpected issues.
 *
 * SOURCE Type @ squareup/items/items.proto at 356:3
 */
Item.Type = $root.lookupEnum('squareup.api.items.Item.Type').values;
/**
 * settings for item visibility in Ecom and Online Store.
 *
 * SOURCE EcomVisibility @ squareup/items/items.proto at 484:3
 */
Item.EcomVisibility = $root.lookupEnum('squareup.api.items.Item.EcomVisibility').values;
/**
 * Contains all data specific to items of type COMBO.
 *
 * SOURCE Combo @ squareup/items/items.proto at 564:3
 */
Item.Combo = $root.lookupType('squareup.api.items.Item.Combo');
fixType(Item.Combo);
Builder.createAndAttachToType(Item.Combo);
/**
 * Each slot on a combo defines a rule set for which variations are required to fulfill that slot.
 * All slots must be fulfilled to sell a combo.
 *
 * SOURCE Slot @ squareup/items/items.proto at 567:5
 */
Item.Combo.Slot = $root.lookupType('squareup.api.items.Item.Combo.Slot');
fixType(Item.Combo.Slot);
Builder.createAndAttachToType(Item.Combo.Slot);
/**
 * A price adjustment for a specific item variation for a specific combo slot
 *
 * SOURCE PriceAdjustment @ squareup/items/items.proto at 598:7
 */
Item.Combo.Slot.PriceAdjustment = $root.lookupType('squareup.api.items.Item.Combo.Slot.PriceAdjustment');
fixType(Item.Combo.Slot.PriceAdjustment);
Builder.createAndAttachToType(Item.Combo.Slot.PriceAdjustment);
/**
 * SOURCE Event @ squareup/items/items.proto at 645:3
 */
Item.Event = $root.lookupType('squareup.api.items.Item.Event');
fixType(Item.Event);
Builder.createAndAttachToType(Item.Event);
/**
 * SOURCE CategoryId @ squareup/items/items.proto at 673:1
 */
export const CategoryId = $root.lookupType('squareup.api.items.CategoryId');
fixType(CategoryId);
Builder.createAndAttachToType(CategoryId);
/**
 * SOURCE ImageReference @ squareup/items/items.proto at 678:1
 */
export const ImageReference = $root.lookupType('squareup.api.items.ImageReference');
fixType(ImageReference);
Builder.createAndAttachToType(ImageReference);
/**
 * SOURCE ItemModifierList @ squareup/items/items.proto at 683:1
 */
export const ItemModifierList = $root.lookupType('squareup.api.items.ItemModifierList');
fixType(ItemModifierList);
Builder.createAndAttachToType(ItemModifierList);
/**
 * SOURCE SelectionType @ squareup/items/items.proto at 696:3
 */
ItemModifierList.SelectionType = $root.lookupEnum('squareup.api.items.ItemModifierList.SelectionType').values;
/**
 * SOURCE ModifierType @ squareup/items/items.proto at 703:3
 */
ItemModifierList.ModifierType = $root.lookupEnum('squareup.api.items.ItemModifierList.ModifierType').values;
/**
 * SOURCE ItemModifierOption @ squareup/items/items.proto at 858:1
 */
export const ItemModifierOption = $root.lookupType('squareup.api.items.ItemModifierOption');
fixType(ItemModifierOption);
Builder.createAndAttachToType(ItemModifierOption);
/**
 * SOURCE ItemOptionValueForItemVariation @ squareup/items/items.proto at 918:1
 */
export const ItemOptionValueForItemVariation = $root.lookupType('squareup.api.items.ItemOptionValueForItemVariation');
fixType(ItemOptionValueForItemVariation);
Builder.createAndAttachToType(ItemOptionValueForItemVariation);
/**
 * A non-blocking period of time within a service.
 *
 * SOURCE Intermission @ squareup/items/items.proto at 924:1
 */
export const Intermission = $root.lookupType('squareup.api.items.Intermission');
fixType(Intermission);
Builder.createAndAttachToType(Intermission);
/**
 * SOURCE ItemVariation @ squareup/items/items.proto at 932:1
 */
export const ItemVariation = $root.lookupType('squareup.api.items.ItemVariation');
fixType(ItemVariation);
Builder.createAndAttachToType(ItemVariation);
/**
 * field 11 used by id
 * settings for inventory reminder
 *
 * SOURCE InventoryAlertType @ squareup/items/items.proto at 977:3
 */
ItemVariation.InventoryAlertType = $root.lookupEnum('squareup.api.items.ItemVariation.InventoryAlertType').values;
/**
 * A fixed grouping of ItemVariations. Read-only for now.
 *
 * SOURCE Bundle @ squareup/items/items.proto at 1120:3
 */
ItemVariation.Bundle = $root.lookupType('squareup.api.items.ItemVariation.Bundle');
fixType(ItemVariation.Bundle);
Builder.createAndAttachToType(ItemVariation.Bundle);
/**
 * A component of a Bundle. Read-only for now.
 *
 * SOURCE Component @ squareup/items/items.proto at 1126:5
 */
ItemVariation.Bundle.Component = $root.lookupType('squareup.api.items.ItemVariation.Bundle.Component');
fixType(ItemVariation.Bundle.Component);
Builder.createAndAttachToType(ItemVariation.Bundle.Component);
/**
 * @desc Cost of materials required to perform a service
 *
 * SOURCE ServiceCost @ squareup/items/items.proto at 1159:3
 */
ItemVariation.ServiceCost = $root.lookupType('squareup.api.items.ItemVariation.ServiceCost');
fixType(ItemVariation.ServiceCost);
Builder.createAndAttachToType(ItemVariation.ServiceCost);
/**
 * SOURCE VendorInformation @ squareup/items/items.proto at 1178:3
 */
ItemVariation.VendorInformation = $root.lookupType('squareup.api.items.ItemVariation.VendorInformation');
fixType(ItemVariation.VendorInformation);
Builder.createAndAttachToType(ItemVariation.VendorInformation);
/**
 * SOURCE ItemImage @ squareup/items/items.proto at 1258:1
 */
export const ItemImage = $root.lookupType('squareup.api.items.ItemImage');
fixType(ItemImage);
Builder.createAndAttachToType(ItemImage);
/**
 * SOURCE MenuCategory @ squareup/items/items.proto at 1351:1
 */
export const MenuCategory = $root.lookupType('squareup.api.items.MenuCategory');
fixType(MenuCategory);
Builder.createAndAttachToType(MenuCategory);
/**
 * SOURCE CatalogCategoryType @ squareup/items/items.proto at 1435:3
 */
MenuCategory.CatalogCategoryType = $root.lookupEnum('squareup.api.items.MenuCategory.CatalogCategoryType').values;
/**
 * SOURCE Fee @ squareup/items/items.proto at 1450:1
 */
export const Fee = $root.lookupType('squareup.api.items.Fee');
fixType(Fee);
Builder.createAndAttachToType(Fee);
/**
 * SOURCE AdjustmentType @ squareup/items/items.proto at 1455:3
 */
Fee.AdjustmentType = $root.lookupEnum('squareup.api.items.Fee.AdjustmentType').values;
/**
 * SOURCE InclusionType @ squareup/items/items.proto at 1484:3
 */
Fee.InclusionType = $root.lookupEnum('squareup.api.items.Fee.InclusionType').values;
/**
 * There are 4 types of discounts:
 * - fixed flat amount (discount_type = FIXED, percentage = null, amount > 0)
 *   => The merchant enters an amount when editing the discount in the items library.
 * - fixed percentage (discount_type = FIXED, percentage > 0, amount = null)
 *   => The merchant enters a percentage when editing the discount in the items library.
 * - variable (aka custom) flat amount (discount_type = VARIABLE_AMOUNT, percentage = null, amount = 0)
 *   => The merchant enters an amount at sales time.
 * - variable (aka custom) percentage (discount_type = VARIABLE_PERCENTAGE, percentage = 0, amount = null)
 *   => The merchant enters a percentage at sales time.
 *
 * SOURCE Discount @ squareup/items/items.proto at 1863:1
 */
export const Discount = $root.lookupType('squareup.api.items.Discount');
fixType(Discount);
Builder.createAndAttachToType(Discount);
/**
 * SOURCE DiscountType @ squareup/items/items.proto at 1896:3
 */
Discount.DiscountType = $root.lookupEnum('squareup.api.items.Discount.DiscountType').values;
/**
 * This field tracks whether a Discount is a COMP Discount or not. A COMP Discount is a 100%
 * Discount that indicates that an item was sold but not charged on a bill.
 *
 * All other Discounts are MANUALLY_APPLIED regardless of if the corresponding Discount was
 * applied manually by a person or automatically by a pricing rule.
 *
 * Example: A non-comp Discount that is applied automatically will have a Discount
 * ApplicationMethod of MANUALLY_APPLIED and a DiscountLineItem ApplicationMethod of PRICING_RULE.
 *
 * SOURCE ApplicationMethod @ squareup/items/items.proto at 1924:3
 */
Discount.ApplicationMethod = $root.lookupEnum('squareup.api.items.Discount.ApplicationMethod').values;
/**
 * Indicates whether the application of this discount modifies the tax basis or not
 *
 * SOURCE ModifyTaxBasis @ squareup/items/items.proto at 1973:3
 */
Discount.ModifyTaxBasis = $root.lookupEnum('squareup.api.items.Discount.ModifyTaxBasis').values;
/**
 * Dining options are used to to note where/how an order is consumed,
 * e.g. “For Here”, “To Go”, “Catering”. This gives Sellers powerful reporting
 * abilities and helps kitchens prep food quickly and correctly.
 *
 * PRD https://docs.google.com/a/squareup.com/document/d/1HKNG4JOlAPyvIYfGaD9gOwwyw6Dwv7-XlsjIXFxBl70/edit
 *
 * Requires CatalogFeature.DINING_OPTIONS in the COGS sync request scope for
 * dining option objects to be returned.
 *
 * SOURCE DiningOption @ squareup/items/items.proto at 2071:1
 */
export const DiningOption = $root.lookupType('squareup.api.items.DiningOption');
fixType(DiningOption);
Builder.createAndAttachToType(DiningOption);
/**
 * A tax rule defined specifically for fees with TAX adjustment type.
 *
 * Requires CatalogFeature.CONDITIONAL_TAXES in the COGS sync request scope for
 * tax rule objects to be returned.
 *
 * SOURCE TaxRule @ squareup/items/items.proto at 2108:1
 */
export const TaxRule = $root.lookupType('squareup.api.items.TaxRule');
fixType(TaxRule);
Builder.createAndAttachToType(TaxRule);
/**
 * The condition is true if and only if the specified predicate is evaluated to true.
 * Only one predicate may be present.
 *
 * We will add other types of predicates here for future more advanced rule support.
 * The condition will be a conjunction of all specified predicates.
 *
 * SOURCE Condition @ squareup/items/items.proto at 2127:3
 */
TaxRule.Condition = $root.lookupType('squareup.api.items.TaxRule.Condition');
fixType(TaxRule.Condition);
Builder.createAndAttachToType(TaxRule.Condition);
/**
 * PageLayout describes layouts for pages within a catalog.
 *
 * SOURCE PageLayout @ squareup/items/items.proto at 2248:1
 */
export const PageLayout = $root.lookupEnum('squareup.api.items.PageLayout').values;
/**
 * Specifies the device form factor for which a menu is designed.
 *
 * SOURCE DeviceFormFactor @ squareup/items/items.proto at 2300:1
 */
export const DeviceFormFactor = $root.lookupEnum('squareup.api.items.DeviceFormFactor').values;
/**
 * A ticket template is a configurable name and identifier that is used to create
 * pre-defined open tickets.  Merchants create a list of ticket templates that they
 * then use to create open ticket instances.  This is useful as a rudimentary form of
 * table management (e.g., ticket templates called "Table 1", "Table 2", etc.).
 *
 * Ticket templates are stored in an ordered list within a ticket group, referenced
 * by id.
 *
 * SOURCE TicketTemplate @ squareup/items/items.proto at 2388:1
 */
export const TicketTemplate = $root.lookupType('squareup.api.items.TicketTemplate');
fixType(TicketTemplate);
Builder.createAndAttachToType(TicketTemplate);
/**
 * Ticket groups are ordered collections of ticket templates.  In a table management
 * context, a ticket group might be something like "Dining Room", "Bar", or "Patio".
 *
 * SOURCE TicketGroup @ squareup/items/items.proto at 2413:1
 */
export const TicketGroup = $root.lookupType('squareup.api.items.TicketGroup');
fixType(TicketGroup);
Builder.createAndAttachToType(TicketGroup);
/**
 * SOURCE NamingMethod @ squareup/items/items.proto at 2424:3
 */
TicketGroup.NamingMethod = $root.lookupEnum('squareup.api.items.TicketGroup.NamingMethod').values;
/**
 * SOURCE PrefixTableNames @ squareup/items/items.proto at 2448:3
 */
TicketGroup.PrefixTableNames = $root.lookupEnum('squareup.api.items.TicketGroup.PrefixTableNames').values;
/**
 * Menus are a named top level collection used to organize a merchant's catalog into a
 * directed graph.
 *
 * SOURCE Menu @ squareup/items/items.proto at 2468:1
 */
export const Menu = $root.lookupType('squareup.api.items.Menu');
fixType(Menu);
Builder.createAndAttachToType(Menu);
/**
 * SOURCE TagReference @ squareup/items/items.proto at 2514:1
 */
export const TagReference = $root.lookupType('squareup.api.items.TagReference');
fixType(TagReference);
Builder.createAndAttachToType(TagReference);
/**
 * Surcharges are used to represent percentage-based, flat, or basis charges added to sales.
 * The first use case for surcharges is adding auto-gratuities to large party checks within the Restaurant POS,
 * but additional Types can be defined for future use cases.
 * Surcharges are analogous to Fees in that they are represented by individual line items that aggregate to a total amount.
 * They differ from customer-provided tips in that they are non-negotiable additions to the sale.
 *
 * SOURCE Surcharge @ squareup/items/items.proto at 2729:1
 */
export const Surcharge = $root.lookupType('squareup.api.items.Surcharge');
fixType(Surcharge);
Builder.createAndAttachToType(Surcharge);
/**
 * SOURCE Type @ squareup/items/items.proto at 2752:3
 */
Surcharge.Type = $root.lookupEnum('squareup.api.items.Surcharge.Type').values;
/**
 * SOURCE AutoGratuitySettings @ squareup/items/items.proto at 2767:3
 */
Surcharge.AutoGratuitySettings = $root.lookupType('squareup.api.items.Surcharge.AutoGratuitySettings');
fixType(Surcharge.AutoGratuitySettings);
Builder.createAndAttachToType(Surcharge.AutoGratuitySettings);
/**
 * SOURCE AutoEnableType @ squareup/items/items.proto at 2772:5
 */
Surcharge.AutoGratuitySettings.AutoEnableType = $root.lookupEnum('squareup.api.items.Surcharge.AutoGratuitySettings.AutoEnableType').values;
/**
 * Indicates whether the surcharge is fixed, variable-percentage, or variable-amount based.
 *
 * SOURCE CalculationType @ squareup/items/items.proto at 2798:3
 */
Surcharge.CalculationType = $root.lookupEnum('squareup.api.items.Surcharge.CalculationType').values;
/**
 * --
 * Indicates what Square Online fulfillment types the service charge should apply to. Only valid for internal
 * usage by Square Online.
 * --
 *
 * SOURCE EcomFulfillmentType @ squareup/items/items.proto at 2810:3
 */
Surcharge.EcomFulfillmentType = $root.lookupEnum('squareup.api.items.Surcharge.EcomFulfillmentType').values;
/**
 * --
 * Indicates how the surcharge should be treated.
 * --
 *
 * SOURCE TreatmentType @ squareup/items/items.proto at 2825:3
 */
Surcharge.TreatmentType = $root.lookupEnum('squareup.api.items.Surcharge.TreatmentType').values;